export type Unsubscribe = () => void;
export type OnChange = <T>(t?: T) => void;
export type Subscribe = (onChange: OnChange) => Unsubscribe;

export const combineSubscribes =
    (...subscribes: Subscribe[]): Subscribe =>
    onChange => {
        const unsubscribes = subscribes.map(s => s(onChange));
        return () => {
            for (const unsubscribe of unsubscribes) {
                unsubscribe();
            }
            unsubscribes.length = 0;
        };
    };
